'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _typeahead = require('../typeahead');

var _typeahead2 = _interopRequireDefault(_typeahead);

var _mixin = require('../../helpers/util/mixin');

var _mixin2 = _interopRequireDefault(_mixin);

var _addClass = require('../../helpers/dom/add-class');

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = require('../../helpers/dom/remove-class');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _toggleClass = require('../../helpers/dom/toggle-class');

var _toggleClass2 = _interopRequireDefault(_toggleClass);

var _makeElement = require('../../helpers/dom/make-element');

var _makeElement2 = _interopRequireDefault(_makeElement);

var _messaging = require('../../mixins/messaging');

var _messaging2 = _interopRequireDefault(_messaging);

var _validation = require('../../mixins/validation');

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # Card Expiration Input
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * An input container for payment expiration details.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new Spark.Payments.CardExpiration(el, {...});
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/payments/card-expiration.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var onValidEvent = document.createEvent('Event');
var onInvalidEvent = document.createEvent('Event');

onValidEvent.initEvent('valid', true, true);
onInvalidEvent.initEvent('invalid', true, true);

var CardExpiration = function (_BaseComponent) {
  _inherits(CardExpiration, _BaseComponent);

  /**
   * CardExpiration constructor.
   * @param {Element} el
   * @param {Object} params
   */
  function CardExpiration(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, CardExpiration);

    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params));

    _this._bindEventListenerCallbacks();
    _this._addEventListeners();
    _this._initTypeahead();
    return _this;
  }

  /**
   * Sets up references
   * @param {Element} el base DOM element
   */


  CardExpiration.prototype._cacheElements = function _cacheElements(el) {
    this.el = el;
    this.inputEl = el ? el.querySelector('input') : undefined;

    if (!this.el || !this.inputEl) {
      throw new Error('CardExpiration markup missing');
    } else {
      if (this.inputEl.value) {
        (0, _addClass2.default)(this.el, 'active');
      }

      this.messageEl = this.el.querySelector('.spark-input__message') || (0, _makeElement2.default)('<span class="spark-input__message"></span>');
    }
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  CardExpiration.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._onBlurBound = this._onBlur.bind(this);
    this._onFocusBound = this._onFocus.bind(this);
    this._onInputBound = this._onInput.bind(this);
    this._onInvalidBound = this._onInvalid.bind(this);
    this._onValidBound = this._onValid.bind(this);
  };

  /**
   * Add event listeners for DOM events.
   */


  CardExpiration.prototype._addEventListeners = function _addEventListeners() {
    this.inputEl.addEventListener('input', this._onInputBound, false);
    this.inputEl.addEventListener('blur', this._onBlurBound, false);
    this.inputEl.addEventListener('focus', this._onFocusBound, false);
    this.inputEl.addEventListener('invalid', this._onInvalidBound, false);
    this.inputEl.addEventListener('valid', this._onValidBound, false);
  };

  /**
   * Remove event listeners for DOM events..
   */


  CardExpiration.prototype._removeEventListeners = function _removeEventListeners() {
    this.inputEl.removeEventListener('input', this._onInputBound, false);
    this.inputEl.removeEventListener('blur', this._onBlurBound, false);
    this.inputEl.removeEventListener('focus', this._onFocusBound, false);
    this.inputEl.removeEventListener('invalid', this._onInvalidBound, false);
    this.inputEl.removeEventListener('valid', this._onValidBound, false);
  };

  /**
   * Initialize internal typeahead to restrict input to desired format
   */


  CardExpiration.prototype._initTypeahead = function _initTypeahead() {
    if (this.inputEl) {
      this.inputEl.dataset.typeaheadFormat = '\\d\\d - \\d\\d';
      this.typeahead = new _typeahead2.default(this.el);
    }
  };

  /**
   * Getter for Month value
   * @return {String}
   */


  /**
   * onBlur callback, for controlling component active state, firing provided callbacks, and running validation
   */
  CardExpiration.prototype._onBlur = function _onBlur() {

    if (!this.inputEl.value) {
      (0, _removeClass2.default)(this.el, 'active');
    }

    this.onBlur.call(this);

    if (this.inputEl.hasAttribute('data-novalidate')) {
      this.inputEl.removeAttribute('data-novalidate');
    }

    if (!this.valid) {
      this.inputEl.dispatchEvent(onInvalidEvent);
    }
  };

  /**
   * onFocus callback, for controlling component active state and firing provided callbacks
   */


  CardExpiration.prototype._onFocus = function _onFocus() {
    (0, _addClass2.default)(this.el, 'active');
    this.onFocus.call(this);
  };

  /**
   * onInput callback, for controlling component active state, parsing user input, firing provided callbacks, and running validation
   */


  CardExpiration.prototype._onInput = function _onInput() {
    var value = this.inputEl ? this.inputEl.value : 0;
    (0, _addClass2.default)(this.el, 'active');

    switch (value.length) {
      case 0:
        this.month = undefined;
        this.year = undefined;
        break;
      case 1:
        if (value > 1) {
          var formattedMonth = '0'.concat(this.inputEl.value, ' - ');
          this.inputEl.value = formattedMonth;
          this.typeahead.setValue(formattedMonth);
          this.typeahead.placeholderEl.innerHTML = '&nbsp;&nbsp; - YY';
          this.typeahead.moveCaret(5);
          this.month = value.slice(0, 2);
          this.year = undefined;
        } else {
          this.year = undefined;
        }
        break;
      case 5:
        {
          var month = value.slice(0, 2);
          if (month >= 1 && month <= 12) {
            this.month = month;
            this.typeahead.moveCaret(5);
          } else {
            this.typeahead.setValue(month.charAt(0));
            this.typeahead.moveCaret(1);
            this.inputEl.value = month.charAt(0);
            this.typeahead.placeholderEl.innerHTML = '&nbsp;' + this.inputEl.placeholder.slice(1);
          }
          this.year = undefined;
          break;
        }
      case 6:
        this.month = value.slice(0, 2);
        this.year = undefined;
        break;
      case 7:
        this.month = value.slice(0, 2);
        this.year = value.substr(-2);
        break;
    }

    this.onInput.call(this);

    this._checkValidity();
  };

  /**
   * Triggers validity events
   */


  CardExpiration.prototype._checkValidity = function _checkValidity() {
    if (!this.inputEl.hasAttribute('data-novalidate')) {
      this.inputEl.dispatchEvent(this.valid ? onValidEvent : onInvalidEvent);
    }
  };

  /**
   * onInvalid method for firing provided callbacks
   */


  CardExpiration.prototype._onInvalid = function _onInvalid() {
    this.onInvalid.call(this);
  };

  /**
   * onValid method for firing provided callbacks
   */


  CardExpiration.prototype._onValid = function _onValid() {
    this.onValid.call(this);
  };

  /**
   * Method for triggering focus on component's input element from outside of component
   */


  CardExpiration.prototype.focus = function focus() {
    this.inputEl.focus();
  };

  /**
   * Returns value as a string of continuous digits in the pattern of MMYY,
   * with no special formatting or spacing
   * @return {String}
   */


  CardExpiration.prototype.valueOf = function valueOf() {
    return this.inputEl.value.replace(/\D/g, '');
  };

  /**
   * Default validate function. This can be overridden by passing a
   * custom validate method as a parameter.
   */


  CardExpiration.prototype.validate = function validate() {
    if (this.validatePattern) {
      this.inputEl.setAttribute('pattern', this.validatePattern);
    }

    this.onValidate(this.valid, this.value, this);

    return this;
  };

  /**
   * Show the input by adding the active state and setting character counts (if necessary).
   */


  CardExpiration.prototype.show = function show() {
    (0, _addClass2.default)(this.el, 'active');
    return this;
  };

  /**
   * Hide the input by removing the active state.
   */


  CardExpiration.prototype.hide = function hide() {
    (0, _removeClass2.default)(this.el, 'active');
    return this;
  };

  /**
   * Set the value of the input.
   * @param {Mixed} value
   */


  CardExpiration.prototype.setValue = function setValue(value) {
    this.value = value;

    if (value) {
      this.show();
    } else {
      this.hide();
    }

    return this;
  };

  /**
   * Get the value of the input.
   * @return {String}
   */


  CardExpiration.prototype.getValue = function getValue() {
    return this.value;
  };

  /**
   * Clear the value of the input.
   */


  CardExpiration.prototype.clearValue = function clearValue() {
    this.value = undefined;
    return this;
  };

  /**
   * Disable the input.
   */


  CardExpiration.prototype.disable = function disable() {
    this.inputEl.attributes.setNamedItem(document.createAttribute('disabled'));
    return this;
  };

  /**
   * Enable the input.
   */


  CardExpiration.prototype.enable = function enable() {
    this.inputEl.removeAttribute('disabled');
    return this;
  };

  _createClass(CardExpiration, [{
    key: 'month',
    get: function get() {
      if (this._month === undefined && this.inputEl.value) {
        if (this.inputEl.value.length >= 2) {
          var month = this.inputEl.value.slice(0, 2);
          return month >= 1 && month <= 12 ? month : this._month;
        }
      }
      return this._month;
    }

    /**
     * Setter for Month Value
     * @param {Number} value
     */
    ,
    set: function set(value) {
      if (value && value >= 1 && value <= 12) {
        value = value.toString();
        this._month = value.length === 2 ? value : '0'.concat(value);
      } else {
        this._month = undefined;
      }

      if (this._month && this._month.length === 2) {
        switch (this.inputEl.value.length) {
          case 0:
          case 1:
            (0, _addClass2.default)(this.el, 'active');
            this.value = this._month;
            break;
          case 2:
            (0, _addClass2.default)(this.el, 'active');
            this.value = this._month;
            if (this.inputEl === document.activeElement) {
              this.typeahead.moveCaret(5);
            }
            break;
          default:
            this.value = this._month + this.inputEl.value.slice(2);
            break;
        }
      } else {
        this._month = undefined;
        this._year = undefined;
        this.typeahead.clearValue();
      }
    }

    /**
     * Getter for Year value
     * @return {String}
     */

  }, {
    key: 'year',
    get: function get() {
      if (this._year === undefined && this.inputEl.value) {
        if (this.inputEl.value.length === 7) {
          return this.inputEl.value.substr(-2);
        }
      }
      return this._year;
    }

    /**
     * Setter for Year value
     * @param {Number} value
     */
    ,
    set: function set(value) {
      if (value >= 0 && value <= 99) {
        value = value.toString();

        this._year = value.length === 2 ? value : '0'.concat(value);
      } else {
        this._year = undefined;
      }

      if (this._year && this._year.length === 2) {
        switch (this.inputEl.value.length) {
          case 0:
          case 1:
            this._year = undefined;
            break;
          default:
            if (this._month) {
              this.value = this._month.concat(' - ', this._year);
            }
            break;
        }
      } else {
        this.value = this.inputEl.value.slice(0, 5);
      }
    }

    /**
     * Getter for Primary Component Value
     * @return {Object}
     */

  }, {
    key: 'value',
    get: function get() {
      return this.valid ? {
        month: this.month,
        year: this.year
      } : undefined;
    }

    /**
     * Setter for Primary Component Value
     * @param {Mixed} val
     */
    ,
    set: function set(val) {
      if (!val) {
        this._month = undefined;
        this._year = undefined;

        if (this.inputEl) {
          this.inputEl.value = '';
        }

        if (this.typeahead) {
          this.typeahead.clearValue();
          this.typeahead.placeholderEl.innerText = this.inputEl.placeholder;
        }
      } else if (val.hasOwnProperty('year') || val.hasOwnProperty('month')) {
        this.month = val.month || this.month;
        this.year = val.year || this.year;
      } else if (this.typeahead && val && typeof val === 'string') {
        this.typeahead.setValue(val);
      }

      if (this.inputEl === document.activeElement) {
        (0, _addClass2.default)(this.el, 'active');
      } else {
        (0, _toggleClass2.default)(this.el, 'active', this.inputEl.value);
      }
    }

    /**
     * Getter for Valid state, returns true if component value is valid, false if not
     * @return {Boolean}
     */

  }, {
    key: 'valid',
    get: function get() {
      var format = new RegExp(this.inputEl.getAttribute('pattern'));
      return this.month && this.year ? this.inputEl.willValidate && format.test(this.inputEl.value) : false;
    }
  }]);

  return CardExpiration;
}(_base2.default);

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */


CardExpiration.prototype._whitelistedParams = ['onInput', 'onBlur', 'onFocus', 'onInvalid', 'onValid', 'onValidate', 'validate', 'validatePattern'];

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */
CardExpiration.prototype.defaults = {
  el: null,
  inputEl: null,
  validate: null,
  validatePattern: null,
  onInput: function onInput() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onInvalid: function onInvalid() {},
  onValid: function onValid() {},
  onValidate: function onValidate() {}
};

(0, _mixin2.default)(CardExpiration.prototype, _messaging2.default, _validation2.default);

exports.default = CardExpiration;
module.exports = exports['default'];
//# sourceMappingURL=card-expiration.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/components/payments/card-expiration.js
// module id = 398
// module chunks = 0